import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '@service/auth.service';
import { AccessRequestStatus } from 'icreate/common/models/access-request';
import { PublishRequestStatus } from 'icreate/common/models/approval-request';
import dayjs from 'dayjs';
import { Router } from '@angular/router';
import { NotificationsService } from '@service/homepage-notifications.service';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

@Component({
    selector: 'app-homepage-notification',
    templateUrl: './homepage-notification.component.html',
    styleUrls: ['./homepage-notification.component.css'],
    standalone: false,
})
export class HomepageNotificationComponent implements OnInit {
    @Input() notification;

    currentUser: { name: string; oid: string; email: string };

    constructor(
        private authService: AuthService,
        private notificationsService: NotificationsService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.currentUser = this.authService.getCurrentUser();
    }

    async openVessel() {
        if (this.isPublishRequestedNotification()) {
            await this.router.navigateByUrl(`/home/${this.notification.shipyardId}/${this.notification.vesselId}`);
            return;
        }
        await this.router.navigateByUrl(`/home/${this.notification.shipyardId}/${this.notification.vesselId}`);
    }

    isAccessPendingNotification(): boolean {
        return (
            this.showNotification(AccessRequestStatus.Pending) && this.notification.ownerOid === this.currentUser.oid
        );
    }

    isGuestEditingNotification(): boolean {
        return (
            this.showNotification(AccessRequestStatus.Editing) && this.notification.ownerOid === this.currentUser.oid
        );
    }

    isAccessGrantedNotification(): boolean {
        return (
            this.showNotification(AccessRequestStatus.Accepted) && this.notification.userOid === this.currentUser.oid
        );
    }

    isAccessRejectedNotification(): boolean {
        return (
            this.showNotification(AccessRequestStatus.Rejected) && this.notification.userOid === this.currentUser.oid
        );
    }

    isAccessRemovedNotification(): boolean {
        return this.showNotification(AccessRequestStatus.Removed) && this.notification.userOid === this.currentUser.oid;
    }

    isPublishRequestedNotification(): boolean {
        return (
            this.showNotification(PublishRequestStatus.Pending) &&
            this.notification.approverOid === this.currentUser.oid
        );
    }

    isPublishApprovedNotification(): boolean {
        return (
            this.showNotification(PublishRequestStatus.Accepted) && this.notification.ownerOid === this.currentUser.oid
        );
    }

    isPublishRejectedNotification(): boolean {
        return (
            this.showNotification(PublishRequestStatus.Rejected) && this.notification.ownerOid === this.currentUser.oid
        );
    }

    isHidden(): boolean {
        return this.notification.hidden;
    }

    getUpdatedTime() {
        return (dayjs(this.notification.updatedAt) as any).fromNow();
    }

    async closeAccessNotification() {
        this.notification.hidden = true;
        await this.notificationsService.updateAccessRequest(this.notification.id, true);
    }

    async closePublishNotification() {
        this.notification.hidden = true;
        await this.notificationsService.updatePublishRequest(this.notification.id, true);
    }

    async undoHidden() {
        this.notification.hidden = false;

        if (
            this.isPublishRequestedNotification() ||
            this.isPublishApprovedNotification() ||
            this.isPublishRejectedNotification()
        ) {
            await this.notificationsService.updatePublishRequest(this.notification.id, false);
            return;
        }
        await this.notificationsService.updateAccessRequest(this.notification.id, false);
    }

    showNotification(status): boolean {
        if (!this.notification) return false;
        if (this.notification.hidden) return false;
        return this.notification.requestStatus === status;
    }
}
